var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.item.name))]),_c('td',[_c('b-form-select',{attrs:{"id":_vm.redemption_id,"options":_vm.options},model:{value:(_vm.redemption),callback:function ($$v) {_vm.redemption=$$v},expression:"redemption"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }